import { render, staticRenderFns } from "./DictionariesEdit.vue?vue&type=template&id=36d28ace&"
import script from "./DictionariesEdit.vue?vue&type=script&lang=js&"
export * from "./DictionariesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports